/**
 * Team functionality
 *
 * @description This file includes the required functionality for the team member cards in team poage
 *
 * @return void
 * @access public
 *
 */

import {body, viewportWidth} from './helpers';

export const team = () => {
	const teamCard = document.querySelectorAll( '.js-team-card' );

	/**
	 * Team Card click functionality
	 *
	 * @return void
	 * @since  1.0.0
	 * @access public
	 */
	teamCard.forEach( function ( element, index ) {
		element.addEventListener( 'click', function ( event ) {
			body.classList.add( 'is-modal-open' );

			if ( viewportWidth < 768 ) {
				body.classList.remove( 'is-hidden' );
			}
		} );
	} );

}
